import { render, staticRenderFns } from "./m-gc-step-fulfillment.vue?vue&type=template&id=2f6d3fbc&scoped=true&"
import script from "./m-gc-step-fulfillment.vue?vue&type=script&lang=js&"
export * from "./m-gc-step-fulfillment.vue?vue&type=script&lang=js&"
import style0 from "./m-gc-step-fulfillment.vue?vue&type=style&index=0&id=2f6d3fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6d3fbc",
  null
  
)

export default component.exports